import { Component, computed, inject, input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { APP_CONFIG, Settings } from 'src/app/config/settings';
import { IdentityService } from 'src/app/core/identity.service';
import { SubmittalJobMatchCalculationTypes } from 'src/app/recruiting/candidates/submittal/models/submittal-job-match-calculation-types.model';
import { JobsRoutesHelper } from 'src/app/recruiting/jobs/jobs-routes-helper';
import { UnitDescriptionSecureWindowService } from '../../services/unit-description-secure-window.service';
import { MatchBreakdown } from './models/match-breakdown.model';
import { MatchBreakdownGridComponent } from './match-breakdown-grid/match-breakdown-grid.component';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { TextFormatPipe } from 'src/app/shared/pipes/text-format.pipe';
import { MatchCategoryCandidateComponent } from './match-category-candidate';
import { MatchCategoryChipComponent } from './match-category-chip';
import { MatchCategoryDescriptionComponent } from './match-category-description';

@UntilDestroy()
@Component({
    selector: 'nova-match-breakdown',
    templateUrl: './match-breakdown.component.html',
    styleUrls: ['./match-breakdown.component.scss'],
    standalone: true,
    imports: [
        MatchBreakdownGridComponent,
        MatCardModule,
        MatIconModule,
        TextFormatPipe,
        MatchCategoryCandidateComponent,
        MatchCategoryChipComponent,
        MatchCategoryDescriptionComponent
    ]
})
export class MatchBreakdownComponent {
    matchBreakdown = input<MatchBreakdown>();
    isJobScreen = input<boolean>(false);
    isJobDetailsOnly = input<boolean>(false);
    jobTitle = input<string>('');
    jobDescription = input<string>('');
    calculationTypeEnum = SubmittalJobMatchCalculationTypes;
    candidateName = input<string>('');
    matchCategory = input<string>('');
    hideReviewNotes = input<boolean>(false);
    doNotUseMatchCategory = input<boolean>(false);
    showRequirementsOverrideIndicator = computed(
        () => (this.matchBreakdown()?.jobTrackId ?? 0) > 0 || (this.matchBreakdown()?.unitTrackId ?? 0) > 0
    );
    private readonly _settings: Settings = inject(APP_CONFIG);
    private readonly _identityService = inject(IdentityService);
    private readonly unitDescriptionSecureWindow = inject(UnitDescriptionSecureWindowService);
    openUnitLink($event: MouseEvent, unitDescriptionFormId: string) {
        $event.preventDefault();
        const url = JobsRoutesHelper.getUnitLink(
            unitDescriptionFormId,
            this._identityService.current.contactId,
            this._settings.lotusOneDomain
        );
        this.unitDescriptionSecureWindow.open(url, '_blank', true);
    }
}
